// src/components/RequireAuth.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/useAuth";

export default function RequireAuth({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  // If no user or no uid, redirect to landing
  if (!user || !user.uid) {
    return <Navigate to="/landing" state={{ from: location }} replace />;
  }

  return children;
}